import firebase from "firebase/app"
import "firebase/auth";

import {BaseView} from '../core/view';
import { LinkUtil } from '../utils/link';
import { FirebaseAuthCookie } from './firebase-auth-cookie';

export default BaseView.extend({

    el: '.js-user-logout',

    events: {
        'click': 'logoutUser'
    },

    logoutUser: function (e) {
        e.preventDefault();
        firebase.auth().signOut()
            .then(() => {
                FirebaseAuthCookie.clear();
                LinkUtil.goToUrl('/');
            });
    }
});
